import axios from 'axios';
import { API_URL } from 'appConfig';

export default axios.create({
  baseURL: API_URL,
  timeout: 0,
});
